import { z } from "zod";
import { scheduleApplicationListItemSchema } from "./scheduleApplicationList.schema";

export const SCHEDULE_MARK_BILLED_BULK_LIMIT = 200;

export const scheduleApplicationBillingBaseSchema = z.object({
    id: z.string().uuid(),
    scheduleApplicationId: z.string().uuid(),
    workspaceId: z.string().uuid(),
    billedDateOnly: z.string().date(),
    amount: z.number(),
    createdByUserId: z.number().int().nullable(),
    createdAt: z.coerce.date(),
});

export type ScheduleApplicationBillingBase = z.infer<
    typeof scheduleApplicationBillingBaseSchema
>;

const entityIdSchema = z.number().int().positive();

export const scheduleMarkBilledBodySchema = z.object({
    entityId: entityIdSchema,
    billedDate: z.string().date(),
    amount: z.number().positive().multipleOf(0.01),
});

export type ScheduleMarkBilledBody = z.infer<
    typeof scheduleMarkBilledBodySchema
>;

export const scheduleMarkUnbilledBodySchema = z.object({
    entityId: entityIdSchema,
});

export type ScheduleMarkUnbilledBody = z.infer<
    typeof scheduleMarkUnbilledBodySchema
>;

export const scheduleMarkBilledBulkBodySchema = z.object({
    entityId: entityIdSchema,
    applicationIds: z
        .array(z.string().uuid())
        .min(1)
        .max(SCHEDULE_MARK_BILLED_BULK_LIMIT)
        .refine((ids) => new Set(ids).size === ids.length, {
            message: "Application ids must be unique",
        }),
    billedDate: z.string().date(),
});

export type ScheduleMarkBilledBulkBody = z.infer<
    typeof scheduleMarkBilledBulkBodySchema
>;

export const scheduleBillingActionResponseSchema = z.object({
    application: scheduleApplicationListItemSchema,
});

export const scheduleMarkBilledBulkResponseSchema = z.object({
    applications: z.array(scheduleApplicationListItemSchema),
});

export const scheduleBillingFailureSchema = z.object({
    applicationId: z.string().uuid(),
    message: z.string(),
});

export type ScheduleBillingFailure = z.infer<
    typeof scheduleBillingFailureSchema
>;

/** Bulk is all-or-nothing: every refused schedule is listed and nothing is written. */
export const scheduleMarkBilledBulkErrorSchema = z.object({
    message: z.string(),
    failures: z.array(scheduleBillingFailureSchema),
});

export type ScheduleMarkBilledBulkError = z.infer<
    typeof scheduleMarkBilledBulkErrorSchema
>;
